/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react'
import styled from 'styled-components'

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: solid 1px #e5e5e5;
  border-radius: 3px;
  align-items: center;
  padding: 60px 20px 20px;
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  & > hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid red;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 0;
  }
  & > p:nth-child(2) {
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #2196f3;
    padding-top: 10px;
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    & > p {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.8;
      letter-spacing: 0.4px;
      text-align: center;
      color: #323c47;
    }
  }
  & > p:nth-child(4) {
    font-size: 11px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #9b9b9b;
  }
`

const CostingWrapper = styled.div`
  & > p {
    font-size: 11px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #9b9b9b;
  }
`
const Costing = styled.div`
  display: flex;
  & > span:nth-child(1) {
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #323c47;
    padding-top: 8px;
  }
  & > span:nth-child(2) {
    color: #323c47;
    font-size: 40px;
    letter-spacing: 0.4px;
  }
  & > p {
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #323c47;
    align-self: flex-end;
    padding-bottom: 10px;
  }
`
const HorizontalLine = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  width: 100%;
  margin: 10px 0;
`

export class SavingsCard extends PureComponent {
  render() {
    const {
      savingImage,
      plan,
      number = 0,
      trial = false,
      subTitle,
      tasks,
      projects,
      dataRetention,
      schedulers,
      server,
      storage,
      cost,
      ram,
      core,
      ipRotation,
      support
    } = this.props
    return (
      <CardWrapper>
        {savingImage === 'trial' ? (
          <img src={require('../static/trial_plan.svg')} alt="compass" />
        ) : savingImage === 'basic' ? (
          <img src={require('../static/basic_plan.svg')} style={{ marginTop: '-20px' }} alt="compass" />
        ) : (
          <img src={require('../static/premiumplan.svg')} style={{ marginTop: '-40px' }} alt="compass" />
        )}
        <p>{plan}</p>
        <Costing>
          <span>$</span>
          <span>{number}</span>
          <p> {subTitle}</p>
        </Costing>
        <p>{cost}</p>
        {/*<HorizontalLine />
        <div>
          <p>{ram}</p>
          <p>{server} Servers</p>
          <p>{storage} Storage</p>
          <p>{core} Core</p>
          <p>
            <span>{dataRetention}</span> Days data retention
          </p>
          <p>{ipRotation}</p>
          <p>Github Integration</p>
          <p>
            <span>{projects}</span> Project
          </p>
          <p>
            <span>{tasks}</span>
          </p>
          <p>
            <span>{schedulers} </span>
            Scheduler(s)
          </p>
          <p>{support}</p>
          <HorizontalLine />
          {trial ? (
            <p style={{ height: '68px' }}> </p>
          ) : (
            <CostingWrapper>
              <Costing>
                <span>$</span>
                <span>2</span>
                <p>/monthly</p>
              </Costing>
              <p>* Additional Cost</p>
            </CostingWrapper>
          )}
          </div>*/}
      </CardWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SavingsCard.js